/**
 * Les premières secondes d'un envoi ne disent rien du débit : la connexion
 * monte en régime, et une estimation sur 200 ms ferait annoncer « 2 s » puis
 * « 9 min ». En dessous, on n'annonce rien.
 */
const MIN_ELAPSED_MS = 1000

/**
 * Secondes restantes avant la fin d'un envoi, au débit moyen observé depuis
 * son début (#310). `null` tant qu'il est trop tôt pour le dire.
 */
export function remainingUploadSeconds(loaded: number, total: number, elapsedMs: number): number | null {
  if (loaded <= 0 || elapsedMs < MIN_ELAPSED_MS) return null
  if (loaded >= total) return 0
  const bytesPerMs = loaded / elapsedMs
  return Math.ceil((total - loaded) / bytesPerMs / 1000)
}
